__webpack_require__.p = "/cryptoApiMarket/";